import { Injectable, Signal } from '@angular/core';
import { IIncomeData, IIncomeModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IIncomeState, IncomeActions, IncomeSelectors } from '../store';

@Injectable({
  providedIn: 'root'
})
export class IncomeStore extends StateAccessService<IIncomeState> {
  readonly state$: Observable<IIncomeState>;

  readonly data$$: Signal<IIncomeData>;
  readonly model$$: Signal<IIncomeModel>;

  constructor() {
    super();

    this.state$ = this.stateFacade.select$(IncomeSelectors.incomeState);

    this.model$$ = this.stateFacade.selectSignal$(IncomeSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(IncomeSelectors.data);
  }

  dispatchIncomeReset() {
    this.stateFacade.dispatch(IncomeActions.reset());
  }
  dispatchSubmitLoad() {
    this.stateFacade.dispatch(IncomeActions.load());
  }
  dispatchIncomeLoadSuccess({ model, data }: { model: IIncomeModel; data: IIncomeData }) {
    this.stateFacade.dispatch(IncomeActions.loadSuccess({ model, data }));
  }

  dispatchSubmitSubmit() {
    this.stateFacade.dispatch(IncomeActions.submit());
  }
  dispatchIncomeSubmitSuccess({ model, data }: { model: IIncomeModel; data: IIncomeData }) {
    this.stateFacade.dispatch(IncomeActions.submitSuccess({ model, data }));
  }
}
